import { RequestStatus } from '../../../../models';
import { type KpisState } from '../KpisState';

const INITIAL_STATE: KpisState = {
  defaultKpisStatus: RequestStatus.Idle,
  kpis: {},
};

export default INITIAL_STATE;
